import { CatharsisArgs, getInvalidationHandler, MegaStore } from '@wix/thunderbolt-catharsis'
import { defaultSchemas as schemas } from './defaultSchemas'

export const createCatharisArgs = (
	catharsisMegaStore: MegaStore,
	componentNodes: CatharsisArgs['extensions']['componentNodes']
) => {
	const onInvalidation = getInvalidationHandler(catharsisMegaStore)

	return { onInvalidation, extensions: { componentNodes, schemas } }
}
